<template>
  <div class="bm-view">
    <baidu-map
      class="bm-view"
      :center="center"
      :zoom="zoom"
      :scroll-wheel-zoom="true"
      :mapClick="false"
      @ready="setDistanceToolInstance"
      @dragend="handleMarkDrag($event)"
      @click="handleMarkClick($event)"
    >
      <div v-for="item in messageList" :key="item.content">
        <bm-label
          :content="item.content"
          :position="item.position"
          :labelStyle="{
            color: 'white',
            fontSize: '12px',
            border: 'none',
            borderRadius: '0.25rem',
            background: 'rgba(0,0,0,75%)',
            padding: '4px',
          }"
          :massClear="false"
          :offset="{ width: 24, height: -10 }"
        />
      </div>
      <bm-local-search
        :keyword="searchKeyword"
        :auto-viewport="true"
      ></bm-local-search>
      <bm-traffic> </bm-traffic>
      <bm-geolocation
        :style="locateStyle"
        :offset="Size"
        anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
        :showAddressBar="false"
        :autoLocation="true"
      ></bm-geolocation>
      <button id="reLocate"></button>
      <bm-control>
        <button id="ranging" @click="openDistanceTool"></button>
      </bm-control>
      <div id="message" ref="message">{{ alertMessage }}</div>
      <transition name="slide">
        <div id="useList" v-show="listShow">
          <h2>您好，<br />接下来想做什么？</h2>
          <!-- <button @click="handleSharePoint"><span></span> 单点共享</button> -->
          <button id="newtask"  @click="handleNewTask"><span></span> 新建任务</button>
          <!-- <button @click="handleSharePoints">
            <span></span> 地理位置共享
          </button>
          <button @click="handleShareMap"><span></span> 自作地图共享</button>
          <button @click="handleShareRoad"><span></span> 单路段共享</button>
          <button @click="handleShareRoads"><span></span> 多路段共享</button>
          <button @click="handleShareRoadWidtWays">
            <span></span> 多点规划共享
          </button> -->
          <!-- <button @click="handleShare('http://localhost:8080/?ms=19')">测试分享面板</button> -->
        </div>
      </transition>
      <button id="unList" :style="unListStyle" @click="toggleList">
        {{ unListCode }}
      </button>
      <div id="center-point" v-show="isCenterPoint"></div>
      <div id="oneMarkAddress" ref="oneMarkAddress" v-show="isAddressState">
        <textarea v-model.lazy="address"></textarea>
      </div>
      <button id="all-point" v-show="isArrCount" @click="showPointPanel">
        {{ count }}
      </button>
      <div id="all-point-panel"></div>
      <button id="oneMarkOK" v-show="isOneMark" @click="oneMarkOK"></button>
      <button id="arrMarkOK" v-show="isArrMark" @click="arrMarkOK"></button>
      <button
        id="isShowSettingIcon"
        v-show="isShowSettingIcon"
        @click="openSettingDialog"
      >
        <Icon icon="uiw:setting" />
      </button>
      <button
        id="isShowNaviIcon"
        v-show="isShowNaviIcon"
        
      >
        <a :href="handleNaviPoint()">  </a>
      </button>

      <div id="state" v-show="state !== null">
        <b>{{ state }}</b>
      </div>
      <div
        id="finishRoadBtn"
        @click="openRoadsPanel"
        v-show="isShowFinishRoadBtn"
        ref="finishRoadBtn"
      >
        
      </div>
    </baidu-map>
    <!-- <Marked
      v-show="isShowMarked"
      @toggleMarked="toggleMarked"
      :address="address"
      :pmtime="pmtime"
      :panorama="panorama"
      :point="point"
      :userMessage="userMessage"
      :isShare="isShare"
      @openCopyCard="handleShare"
    /> -->
    <SharePoints
      :markList="markList"
      :pointsInfo="pointsInfo"
      @getPointsInfo="getPointsInfo"
      @getPointsTime="getPointsTime"
      @openCopyCard="handleShare"
    />
    <!-- 头部 -->
    <div id="header">
      <input
        ref="search"
        type="text"
        placeholder="想去哪里？"
        v-model="searchKeyword"
      />
    </div>
    <Footer />
    <ShareRoad
      ref="roadPanel"
      :roadData="roadList"
      @openCopyCard="handleShare"
    />
    <ShareRoads
      ref="roadsPanel"
      :roadsData="roadList"
      @showFinishRoadBtn="isShowFinishRoadBtn = true"
      @openCopyCard="handleShare"
    />
    <ShareRoadWays
      ref="roadWaysPanel"
      :roadWaysData="rw.roadInfo"
      @openCopyCard="handleShare"
    />
    <div id="RoadActionPanel" v-show="isShowRoadAction">
      <div class="action-item" @click="addRoadFun">
        {{ roadPointCount == 0 ? "设为起点" : "设为终点" }}
      </div>
    </div>
    <div id="RwActionPanel" v-show="isShowRwAction">
      <div class="action-item" @click="handleRwActionClick(1)">起点</div>
      <div class="action-item" @click="handleRwActionClick(2)">途径点</div>
      <div
        v-show="this.taskAlgoType !== 2"
        class="action-item"
        @click="handleRwActionClick(3)"
      >
        终点
      </div>
    </div>

    <div
      id="settingDialog"
      v-show="isOpenSetting"
      @click="
        () => {
          isOpenSetting = false;
        }
      "
    >
      <div
        id="settingDialogWrap"
        @click="
          (e) => {
            e.stopPropagation();
          }
        "
      >
        <button @click="setCurIcon(0)"><img :src="markIcon" />默认</button>
        <button @click="setCurIcon(1)"><img :src="markIconPurple" />紫</button>
        <button @click="setCurIcon(2)"><img :src="markIconRed" />红</button>
        <button @click="setCurIcon(3)"><img :src="markIconOrange" />橙</button>
        <button @click="setCurIcon(4)"><img :src="markIconGreen" />绿</button>
        <button @click="setCurIcon(5)"><img :src="markIconYellow" />黄</button>
      </div>
    </div>

    <div id="algoroadCard" ref="algoroadCard" v-if="this.taskAlgoType === null">
      <p class="card-title">{{ algoroadCardInfo.title }}</p>
      <div class="card-wrap">
        <div class="card-list" v-if="algoroadCardInfo.type === 0">
          <div
            class="item"
            :class="algoroadOpt == 0 ? 'active' : ''"
            @click="changeAlgoroadOpt(0)"
          >
            <i></i>
            <p><span>多途径</span></p>
          </div>
          <div
            class="item"
            :class="algoroadOpt == 1 ? 'active' : ''"
            @click="changeAlgoroadOpt(1)"
          >
            <i></i>
            <p><span>广播型</span></p>
          </div>
          <div
            class="item"
            :class="algoroadOpt == 2 ? 'active' : ''"
            @click="changeAlgoroadOpt(2)"
          >
            <i></i>
            <p><span>回路型</span></p>
          </div>
        </div>
        <div class="card-l" v-if="algoroadCardInfo.type === 1">
          <div class="row">
            <p><span>分享数量：</span>{{ algoroadCardInfo.num }}</p>
          </div>
          <div class="row">
            <p><span>分享备注：</span>{{ algoroadCardInfo.msg }}</p>
          </div>
        </div>
        <div class="card-r">
          <div class="btn" @click="openNavCard">
            <i></i>
            <p>开始导航</p>
          </div>
        </div>
      </div>
    </div>
    <ShareCard ref="ShareCard" />
    <NavigationCard ref="NavigationCard" :navData="navigationData" />
    <TaskPanel
      v-show="taskPanel.show"
      :onClose="
        () => {
          taskPanel.show = false;
        }
      "
      :onSave="addTask"
    />
  </div>
</template>

<script lang="">
import { Icon } from "@iconify/vue2";
import Footer from "@/components/Footer.vue";
import Marked from "@/components/Marked.vue";
import SharePoints from "@/components/SharePoints.vue";
import ShareRoads from "@/components/ShareRoads.vue";
import ShareRoad from "@/components/ShareRoad.vue";
import ShareRoadWays from "@/components/ShareRoadWays.vue";
import ShareCard from "@/components/ShareCard.vue";
import NavigationCard from "@/components/NavigationCard.vue";
import TaskPanel from "@/components/TaskPanel.vue";
import DistanceTool from "bmaplib.distancetool";
import { mapMutations, mapGetters } from "vuex";
import markIcon from "../assets/images/marker-nodisc.png";
import markIconPurple from "../assets/images/marker-nodisc-purple.png";
import markIconRed from "../assets/images/marker-nodisc-red.png";
import markIconGreen from "../assets/images/marker-nodisc-green.png";
import markIconYellow from "../assets/images/marker-nodisc-yellow.png";
import markIconOrange from "../assets/images/marker-nodisc-orange.png";
import smallMarkIcon from "../assets/images/marker-small.png";
import bikeIcon from "../assets/images/bike.png";
import { getShortestPath, getClassify } from "../assets/js/ways_algorithm.js";
import { Edge } from "../assets/js/new_conf.js";
import { io } from "socket.io-client";
import Vue from 'vue'//新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码
import VueCookies from 'vue-cookies'//新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码
Vue.use(VueCookies)//新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码代码新加代码新加代码

export default {
  unmount() {
    distanceTool && distanceTool.close();
  },
  components: {
    Icon,
    Footer,
    Marked,
    SharePoints,
    ShareRoad,
    ShareRoads,
    ShareRoadWays,
    ShareCard,
    NavigationCard,
    TaskPanel,
  },
  computed: {
    ...mapGetters(["currentOpt"]),
    isShowMarked() {
      return this.$store.state.isMarked;
    },
    taskType() {
      return this.$store.state.taskType;
    },
  },
  data() {
    return {
      socket: io({
        reconnection: true,
        forceNew: true,
      }),
      messageList: [],
      animPathPoints: [],
      center: { lng: 113.268554, lat: 23.134538 },
      zoom: 10,
      alldistance: 0.0,
      Size: {
        width: 30,
        height: 85,
      },
      locateStyle: {
        opacity: "0",
      },
      unListCode: "×",
      unListStyle: {
        background: "#ff5252",
      },
      searchKeyword: "",
      listShow: true,
      markInfo: {},
      address: "",
      panorama: "",
      count: 0,
      state: null,
      point: null,
      jiaotongtool: "",
      pmtime: null,
      messageTime: [],
      isCenterPoint: false,
      isOneMark: false,
      isArrMark: false,
      isArrCount: false,
      isAddressState: false,
      markList: [],
      roadList: [],
      roadPointCount: 0,
      roadObject: {},
      isShowFinishRoadBtn: false,
      isShare: true,
      rw: {
        roadInfo: {
          startPoint: "",
          endPoint: "",
          ways: [],
          startAddress: "",
          endAddress: "",
          minimum: [],
        },
        roadStatus: 0,
      },
      isShowRwAction: false,
      isShowRoadAction: false,
      userMessage: null,
      pointsInfo: "",
      // 选择算法
      algoroadOpt: 0,
      alertMessage: "",
      callAppLink: "",
      // 导航面板数据
      navigationData: {},
      algoroadCardInfo: {
        type: 0,
        num: 0,
        msg: "",
        title: "多点规划",
      },
      taskPanel: {
        show: false,
      },
      markType: 0,
      taskAlgoType: null,
      isOpenSetting: false,
      isShowSettingIcon: false,
      isShowNaviIcon: true,
      curIcon: 0,
      markIcon,
      markIconRed,
      markIconPurple,
      markIconGreen,
      markIconYellow,
      markIconOrange,
    };
  },
  methods: {
    getCurIcon(iconNum = this.curIcon) {
      switch (iconNum) {
        case 0:
          return markIcon;
        case 1:
          return markIconPurple;
        case 2:
          return markIconRed;
        case 3:
          return markIconOrange;
        case 4:
          return markIconGreen;
        case 5:
          return markIconYellow;
        default:
          return markIcon;
      }
    },
    setCurIcon(idx) {
      this.curIcon = idx;
      this.isOpenSetting = false;
    },
    showSettingIcon() {
      this.isShowSettingIcon = true;
    },
    showNaviIcon() {
      this.isShowNaviIcon = true;
    },
    handleNaviPoint() {
      let _this = this;
      let lat =
        _this.rw.roadInfo.endPoint.lat ||
        (_this.rw.roadInfo.ways.length >= 1
          ? _this.rw.roadInfo.ways[0].point.lat
          : undefined) ||
        (_this.roadList.length >= 1 ? _this.roadList[0].end.lat : undefined);
      const lng =
        _this.rw.roadInfo.endPoint.lng ||
        (_this.rw.roadInfo.ways.length >= 1
          ? _this.rw.roadInfo.ways[0].point.lng
          : undefined) ||
        (_this.roadList.length >= 1 ? _this.roadList[0].end.lng : undefined);
       return `baidumap://map/navi?location=${lat},${lng}&coord_type=bd09ll&type=BLK&src=ios.baidu.openAPIdemo`;
      //return 'qqmap://map/routeplan?type=drive&tocoord=${lat},${lng}&referer=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77'
    },
    openSettingDialog() {
      this.isOpenSetting = true;
    },
    // 显示分享链接面板
    handleShare(link) {
      this.$refs.ShareCard.showCard();
      this.$refs.ShareCard.linkTxt = link;
      wx.ready(function () {
        wx.updateAppMessageShareData({
          title: "您的好友给你分享了坐标信息",
          desc: "点击即可查看更多详细内容 - 智慧共享导航",
          link: link,
          imgUrl: "https://i.loli.net/2020/12/21/Yr1iysTULx2ZBob.png",
          success: function () {},
        });
      });
    },
    // 获取地址栏传参
    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(decodeURI(r[2]));
      return null;
    },
    setDistanceToolInstance({ map }) {
      let _this = this;
      _this.distanceTool = new DistanceTool(map, { lineStroke: 2 });
      window.map = map;
      _this.addMap();
      // 解析地址栏参数
      let id = _this.GetQueryString("ms");
      if (id !== null) 
      {
        // 状态改变
        ////alert("a");
        _this.unListStyle = { background: "#0b99f1" };
        _this.listShow = false;
        _this.unListCode = "";
        _this.state = "查看共享标记";
        // 数据get
        // TODO:
        ////alert("b");
        this.$http
          .get(`/service/sharelist/${id}`)
          .then(function (oRes) {
            ////alert("d");
            oRes = oRes.data;
            ////alert("e");
            ////alert(oRes.type);
            switch (oRes.type) {
              case "one":
                _this.one(oRes);
                break;
              case "points":
                _this.points(oRes);
                break;
              case "road":
                _this.road(oRes);
                break;
              case "roads":
                _this.roads(oRes);
                break;
              case "algoroad":
              ////alert("f");
              let content1 = window.prompt("请输入账号","Johnson");
              let content2 = window.prompt("验证密码","●●●●●●●●");
              if(content1!="Johnson")
              {alert("验证失败！");
              break;}
              if(content1!="●●●●●●●●")
                _this.algoroad(oRes);
                else
                alert("验证失败！");
                ////alert("G");
                break;
            }
          })
          .catch(function (error) {
            //alert("您访问的共享标记不存在。");
            console.log(error);
          });
        // http End
      }
    },
    // LoadType - one
    one(res) {
      let _this = this,
        point = res.point.split(","),
        address = res.address,
        pmtime = res.apartTime,
        panorama = res.panorama,
        userMessage = res.info;
      _this.center.lng = point[0];
      _this.center.lat = point[1];
      var myIcon = new BMap.Icon(markIcon, new BMap.Size(64, 76));
      var marker = new BMap.Marker(new BMap.Point(point[0], point[1]), {
        icon: myIcon,
      });
      map.addOverlay(marker);
      // 标记点击事件
      marker.addEventListener("click", function () {
        event.stopPropagation();
        _this.isShow = true;
        _this.toggleMarked();
        _this.isShare = false;
        _this.address = address; // 位置经纬
        _this.$store.dispatch("bindTime", pmtime);
        _this.panorama = panorama;
        _this.userMessage = userMessage;
      });
    },
    // LoadType - points
    points(res) 
    {
      let _this = this,
        point = res.point.split(","),
        address = res.address,
        pmtime = res.apartTime,
        panorama = res.panorama,
        userMessage = res.info,
        count = 0;
      _this.center.lng = point[0].split(":")[0];
      _this.center.lat = point[0].split(":")[1];
      _this.count = point.length;
      _this.isArrCount = true;
      console.log(res);
     ////alert("1");
      var myIcon = new BMap.Icon(markIcon, new BMap.Size(64, 76));
      
      //var msgarrn=-1;
      ////alert("2");
      point.forEach((item, index) => 
      {//msgarrn=msgarrn+1;
        let marker = new BMap.Marker(
          new BMap.Point(item.split(":")[0], item.split(":")[1]),
          {
            icon: myIcon,
          }
        );
        ////alert("3");
        count++;
        marker.setLabel(_this.getNumberLabel(count));
        ////alert("4");
        let info = res.info
            ? res.info
            : "<span style='  padding: 1px 5px;background: #0b99f1;color: #fff;font-weight: bold;border-radius: 4px;margin: 10px 5px;'>留言</span>还没有填写留言~",
          time = res.apartTime.split(",")[_this.count - 1]
            ? res.apartTime.split(",")[_this.count - 1]
            : "<br><span style='  padding: 1px 5px;background: #0b99f1;color: #fff;font-weight: bold;border-radius: 4px;margin: 10px 5px;'>时间</span>还没有选择约定时间~";
            ////alert("5");
            map.addOverlay(marker);
            ////alert("6");
            var labelopts = {
              position: new BMap.Point(item.split(":")[0],item.split(":")[1]),// 指定文本标注所在的地理位置 
              offset: new BMap.Size(5,-30)// 设置文本偏移量
            };
            ////alert("7");

            var labelmsg = new BMap.Label (lvmsgarr[msgarrn],labelopts); 
            labelmsg.setStyle({
              color:"#fff",
              fontSize:"14px",
              backgroundColor:"#84C1FF", 
              border:"0",
              fontWeight:"bold"
            });
            ////alert("8");
            map.addOverlay(labelmsg);
            ////alert("9");
           var opts = {
            width: 150, // 宽
            height: 70, // 高
            title: info, // 备注
            // message: "",
           };
        ////alert("10");
        var infoWindow = new BMap.InfoWindow(time, opts); // 创建
        map.addOverlay(infoWindow);
        ////alert("11");
        infoWindow.addEventListener("click", function (e) {
          let messageCount = e.target.Yc.nextElementSibling.innerHTML;
          opts.title = res.info
            ? `<span style='  padding: 1px 5px;background: #0b99f1;color: #fff;font-weight: bold;border-radius: 4px;margin: 10px 5px;'>留言</span>${res.info}`
            : "<span style='  padding: 1px 5px;background: #0b99f1;color: #fff;font-weight: bold;border-radius: 4px;margin: 10px 5px;'>留言</span>还没有填写留言~";
          time = res.apartTime.split(",")[messageCount - 1]
            ? `<br><span style='  padding: 1px 5px;background: #0b99f1;color: #fff;font-weight: bold;border-radius: 4px;margin: 10px 5px;'>时间</span>${
                res.apartTime.split(",")[messageCount - 1]
              }`
            : "<br><span style='  padding: 1px 5px;background: #0b99f1;color: #fff;font-weight: bold;border-radius: 4px;margin: 10px 5px;'>时间</span>还没有选择约定时间~";
          infoWindow = new BMap.InfoWindow(time, opts);
          map.openInfoWindow(
            infoWindow,
            new BMap.Point(all.point.split(":")[0], all.point.split(":")[1])
          ); //开启信息窗口
        });
        // 给多点面板嵌入数据
        let all = {
          point: "",
          count: "",
          address: "",
          pmtime: "",
          apartTime: "",
        };
        all.count = count;
        all.point = item;
        all.address = res.address.split(",")[index];
        all.pmtime = res.apartTime.split(",")[index];
        _this.markList.push(all);
      });
      _this.pointsInfo = res.info;
      // 打开导航面板
      this.setAlgoroadCardInfo(1, point.length, userMessage, "地理位置共享");
      // this.setShowAlgoroadCard(1);
      // 数据给到导航面板
      let navObject = {};
      let mergeArr = [];
      for (let k = 0; k < this.markList.length; k++) {
        let item = this.markList[k].point;
        let point = new BMap.Point(item.split(":")[0], item.split(":")[1]);
        mergeArr.push({ point, address: this.markList[k].address });
      }
      this.$set(navObject, "type", "points");
      this.$set(navObject, "data", mergeArr);
      this.navigationData = navObject;
    },
    // LoadType - road
    road(res) {
      let start = JSON.parse(res.startPoint),
        end = JSON.parse(res.endPoint),
        startPoint = JSON.parse(start.point),
        endPoint = JSON.parse(end.point),
        message = res.info;
      startPoint = new BMap.Point(startPoint.lng, startPoint.lat);
      endPoint = new BMap.Point(endPoint.lng, endPoint.lat);
      // 生成路段信息
      this.getTransit(startPoint, endPoint);
    },
    // LoadType - roads
    roads(res) {
      let roadsList = res.middlePoint;
      // 把字符串转换回数组对象格式
      roadsList = JSON.parse(roadsList);
      for (let i = 0; i < roadsList.length; i++) {
        roadsList[i] = JSON.parse(roadsList[i]);
        roadsList[i].start = JSON.parse(roadsList[i].start);
        roadsList[i].end = JSON.parse(roadsList[i].end);
        // 生成路线信息
        let startPoint = new BMap.Point(
          roadsList[i].start.lng,
          roadsList[i].start.lat
        );
        let endPoint = new BMap.Point(
          roadsList[i].end.lng,
          roadsList[i].end.lat
        );
        this.getTransit(startPoint, endPoint);
      }
    },
    algoroad(res) {

      this.pointsInfo = res.info;

      let algoroadList = res.middlePoint;
      // 把字符串转换回数组对象格式
      algoroadList = JSON.parse(algoroadList);
      // 数组所有坐标都重新实例化（解决生成不了路线bug）
      algoroadList.startPoint = new BMap.Point(
        algoroadList.startPoint.lng,
        algoroadList.startPoint.lat
      );
      algoroadList.endPoint = new BMap.Point(
        algoroadList.endPoint.lng,
        algoroadList.endPoint.lat
      );
      for (let i = 0; i < algoroadList.ways.length; i++) {
        algoroadList.ways[i].point = new BMap.Point(
          algoroadList.ways[i].point.lng,
          algoroadList.ways[i].point.lat
        );
      }
      // 生成路线信息
      //this.rw.roadInfo = alggetTransitoroadList;
      this.rw.roadInfo = algoroadList;
      if (!this.rw.roadInfo.ways.endPoint) {
         this.handleTspStart(this.jiaotongtool);
        
        // this.algoroadOpt = 2;
        // this.setShowAlgoroadCard();
      } else {
        this.handleRwStart(this.jiaotongtool);
        // this.algoroadOpt = 0;
        // this.setShowAlgoroadCard(1);
      }
    },
    // 任务中继器
    handleNewTask() {
      this.animPathPoints = [];
      this.taskPanel.show = !this.taskPanel.show;
      this.changeOpt(7);
      this.toggleList();
      this.resetRoadData();
      this.resetRwData();
      this.resetMapData();
      this.state = " 自定义路段";
      this.$store.dispatch("changeTask", ["type", 0]);

      map.clearOverlays();
      this.count = 0;
      this.isCenterPoint = false;
      this.isOneMark = false;
      this.isArrMark = false;
      this.isArrCount = false;
      this.isAddressState = false;
      this.addTask();
    },
    addTask() {
      const handlePatrol = () => {
        this.handleShareRoads();
        this.state = " 自定义路段";
      };
      const handleDownwind = () => {
        this.handleShareRoadWidtWays(0);
        this.state = " 顺路派送";
      };
      const handleCourier = () => {
        this.handleShareRoadWidtWays(2);
        this.state = " 回路派送";
      };
      const handleBroadcast = () => {
        this.handleShareRoadWidtWays(1);
        this.state = " 广播型派送";
      };
      this.isShowSettingIcon = true;
      this.showNaviIcon();
      switch (this.taskType) {
        case 0:
          handlePatrol();
          break;
        case 1:
          handleDownwind();
          break;
        case 2:
          handleCourier();
          break;
        case 3:
          handleBroadcast();
          break;
        default:
          return null;
      }
    },
    // 单点中继器
    handleSharePoint() {
      this.changeOpt(1);
      this.toggleList();
      this.resetRoadData();
      this.resetRwData();
      this.resetMapData();
      this.state = " 单点共享";
      this.isCenterPoint = true;
      this.isOneMark = true;
      this.isArrMark = false;
      this.isArrCount = false;
      this.isAddressState = true;
      this.addMark();
      map.clearOverlays();
      // 清除所有标记
      this.count = 0;
      // 重置标记计数
    },
    // 多点中继器
    handleSharePoints() {
      this.changeOpt(2);
      this.toggleList();
      this.resetRoadData();
      this.resetRwData();
      this.resetMapData();
      this.state = " 地理位置共享";
      this.isCenterPoint = true;
      this.isArrMark = true;
      this.isArrCount = true;
      this.isOneMark = false;
      this.isAddressState = true;
      this.addMark();
      map.clearOverlays();
      // 清除所有标记
      this.count = 0;
      // 重置标记计数
    },
    // 地图共享中继器
    handleShareMap() {
      this.changeOpt(3);
      this.toggleList();
      this.resetMarkData();
      this.resetRoadData();
      this.resetRwData();
      this.state = " 自作地图共享";
      map.clearOverlays();
      this.count = 0;
      this.isCenterPoint = false;
      this.isAddressState = false;
      let drawingPanel = document.querySelector(".BMapLib_Drawing_panel");
      drawingPanel.style.display = "block";
      // 禁止拖拽
      map.disableDragging();
      // 移动中 允许拖动
      map.addEventListener("touchmove", function (e) {
        map.enableDragging();
      });
      // 触摸结束时触发 禁止拖动
      map.addEventListener("touchend", function (e) {
        map.disableDragging();
      });
    },
    handleShareRoad() {
      this.changeOpt(4);
      this.toggleList();
      this.resetMarkData();
      this.resetRwData();
      this.resetMapData();
      this.state = " 单路段共享";
      this.isCenterPoint = true;
      this.isAddressState = true;
      map.clearOverlays();
      this.count = 0;
      this.roadList = [];
    },
    handleShareRoads() {
      this.changeOpt(5);
      this.toggleList();
      this.resetMarkData();
      this.resetRwData();
      this.resetMapData();
      this.state = " 多路段共享";
      this.isCenterPoint = true;
      this.isAddressState = true;
      this.isShowFinishRoadBtn = true;
      map.clearOverlays();
      // 清除所有标记
      this.count = 0;
      // 重置标记计数
      this.roadList = [];
    },
    handleShareRoadWidtWays(type) {
      if (type === 0 || type === 1 || type === 2) {
        this.taskAlgoType = type;
      } else {
        this.taskAlgoType = null;
      }
      this.messageList = [];
      this.changeOpt(6);
      this.toggleList();
      this.resetMarkData();
      this.resetRoadData();
      this.resetMapData();
      this.state = " 多点规划共享";
      this.isCenterPoint = true;
      this.isAddressState = true;
      this.isShowFinishRoadBtn = true;
      map.clearOverlays();
      // 清除所有标记
      this.count = 0;
      // 重置标记计数
      this.roadList = [];
      // 重置规划面板
      // this.setShowAlgoroadCard(0);
      this.setAlgoroadCardInfo(0, 0, "无", "多点规划");
    },
    addMap(e) {
      // 地图共享 加点画线函数
      var myIcon = new BMap.Icon(smallMarkIcon, new BMap.Size(50, 70));
      var styleOptions = {
        strokeColor: "#0b99f1", //边线颜色。
        fillColor: "#a8deff", //填充颜色。当参数为空时，圆形将没有填充效果。
        strokeWeight: 2, //边线的宽度，以像素为单位。
        strokeOpacity: 0.8, //边线透明度，取值范围0 - 1。
        fillOpacity: 0.4, //填充的透明度，取值范围0 - 1。
        strokeStyle: "dashed", //边线的样式，solid或dashed。
        icon: myIcon,
      };
      //实例化鼠标绘制工具
      var drawingManager = new BMapLib.DrawingManager(map, {
        isOpen: false, //是否开启绘制模式
        enableDrawingTool: true, //是否显示工具栏
        drawingToolOptions: {
          anchor: BMAP_ANCHOR_TOP_LEFT, //位置
          offset: new BMap.Size(15, 175), //偏离值
          drawingModes: [
            // 组件注册
            BMAP_DRAWING_MARKER, // 标记
            // BMAP_DRAWING_CIRCLE, // 圆
            BMAP_DRAWING_POLYLINE, // 线
            BMAP_DRAWING_POLYGON, // 多边形
            // BMAP_DRAWING_RECTANGLE // 矩形
          ],
        },
        markerOptions: styleOptions,
        circleOptions: styleOptions, //圆的样式
        polylineOptions: styleOptions, //线的样式
        polygonOptions: styleOptions, //多边形的样式
        // rectangleOptions: styleOptions, //矩形的样式
      });
      drawingManager.enableCalculate();
      window.drawingManager = drawingManager;
      this.resetMapData();
    },
    handleMarkClick(e) {
      switch (this.currentOpt) {
        default:
          break;
      }
    },
    handleMarkDrag(e) {
      this.$refs.search.blur();
      switch (this.currentOpt) {
        case 1:
          this.addMark(e);
          break;
        case 2:
          this.addMarks(e);
          break;
        case 4:
          this.addRoad(e);
          break;
        case 5:
          this.addRoads(e);
          break;
        case 6:
          this.addRoadWithWays(e);
          break;
        case 7:
          this.addTask(e);
          break;
        default:
          break;
      }
    },
    toggleMarked() {
      this.$store.dispatch("toggleMarked");
    },
    // 给标记添加序号
    getNumberLabel(number) {
      var offsetSize = new BMap.Size(0, 0);
      var labelStyle = {
        color: "#FFF",
        backgroundColor: "#0b99f1",
        border: "0",
        margin: "38px 10px 0",
        fontSize: "12px",
        fontWeight: "bold",
        boxShadow: "0 0 3px #0b99f1",
        borderRadius: "4px",
        padding: "0 10px",
      };

      //不同数字长度设置不同的样式。
      switch ((number + "").length) {
        case 1:
          labelStyle.fontSize = "12px";
          offsetSize = new BMap.Size(4, 2);
          break;
        case 2:
          labelStyle.fontSize = "12px";
          offsetSize = new BMap.Size(2, 4);
          break;
        case 3:
          labelStyle.fontSize = "10px";
          offsetSize = new BMap.Size(-2, 4);
          break;
        default:
          break;
      }

      var label = new BMap.Label(number, {
        offset: offsetSize,
      });
      label.setStyle(labelStyle);
      return label;
    },
    addMark(e) {
      let point = map.getCenter();
      var gc = new BMap.Geocoder();
      let _this = this;
      gc.getLocation(point, function (rs) {
        if (!rs.surroundingPois[0]) {
         // _this.address = "没有找到地址信息，请手动输入。";
        } else {
          let address = rs.surroundingPois[0].address;
          _this.address = address; // 地址
          _this.point = `${point.lng},${point.lat}`; // 坐标
          // var Panor = new BMap.PanoramaService();
          // Panor.getPanoramaByLocation(
          //   new BMap.Point(point.lng, point.lat),
          //   function (data) {
          //     if (data == null) {
          //       _this.panorama = 0;
          //       return;
          //     }
          //     var poiid = data.id;
          //     var panoramaUrl = `http://map.baidu.com/?pid=${poiid}&panoid=${poiid}&panotype=street&heading=353.0&pitch=-9.68000030518`;
          //     _this.panorama = panoramaUrl;
          //   }
          // );
        }
      });
    },
    oneMarkOK() {
      this.toggleMarked();
      this.isShare = true;
    },
    getPointsInfo(info) {
      this.pointsInfo = info;
    },
    getPointsTime(time) {
      this.messageTime.push(time);
    },
    addMarks(e) {
      // 多点定位
      this.addMark();
    },
    arrMarkOK() {
      let _this = this;
      let all = {
        count: "",
        address: "",
        pmtime: "",
        point: "",
        apartTime: "",
      };
      _this.count++;
      all.point = _this.point.toString().replace(",", ":");
      all.count = _this.count;
      all.address = _this.address;
      all.pmtime = _this.pmtime;
      all.apartTime = "";
      _this.markList.push(all);
      let markerPoint = map.getCenter();
      var myIcon = new BMap.Icon(markIcon, new BMap.Size(64, 76));

      let marker = new BMap.Marker(
        new BMap.Point(markerPoint.lng, markerPoint.lat),
        {
          icon: myIcon,
        }
      );
      marker.setLabel(_this.getNumberLabel(_this.count));
      let info = _this.pointsInfo
          ? _this.pointsInfo
          : "<span style='  padding: 1px 5px;background: #0b99f1;color: #fff;font-weight: bold;border-radius: 4px;margin: 10px 5px;'>留言</span>还没有填写留言~",
        time = _this.messageTime[_this.count - 1]
          ? _this.messageTime[_this.count - 1]
          : "<br><span style='  padding: 1px 5px;background: #0b99f1;color: #fff;font-weight: bold;border-radius: 4px;margin: 10px 5px;'>时间</span>还没有选择约定时间~";
      map.addOverlay(marker);
      var opts = {
        width: 150, // 宽
        height: 70, // 高
        title: info, // 备注
        // message: "",
      };
      var infoWindow = new BMap.InfoWindow(time, opts); // 创建
      marker.addEventListener("click", function (e) {
        // _this.showPointPanel();
        let messageCount = e.target.Yc.nextElementSibling.innerHTML;
        opts.title = _this.pointsInfo
          ? `<span style='  padding: 1px 5px;background: #0b99f1;color: #fff;font-weight: bold;border-radius: 4px;margin: 10px 5px;'>留言</span>${_this.pointsInfo}`
          : "<span style='  padding: 1px 5px;background: #0b99f1;color: #fff;font-weight: bold;border-radius: 4px;margin: 10px 5px;'>留言</span>还没有填写留言~";
        time = _this.messageTime[messageCount - 1]
          ? `<br><span style='  padding: 1px 5px;background: #0b99f1;color: #fff;font-weight: bold;border-radius: 4px;margin: 10px 5px;'>时间</span>${
              _this.messageTime[messageCount - 1]
            }`
          : "<br><span style='  padding: 1px 5px;background: #0b99f1;color: #fff;font-weight: bold;border-radius: 4px;margin: 10px 5px;'>时间</span>还没有选择约定时间~";
        infoWindow = new BMap.InfoWindow(time, opts);
        map.openInfoWindow(
          infoWindow,
          new BMap.Point(all.point.split(":")[0], all.point.split(":")[1])
        ); //开启信息窗口
        console.log(all);
      });
      this.alertMsg("标记成功");
    },
    showPointPanel() {
      this.$store.dispatch("togglePointPanel");
    },
    addRoad(e) {
      this.addMark();
      if (this.roadList.length == 0) {
        this.isShowRoadAction = true;
      }
      // this.addRoadFun(e);
    },
    addRoads(e) {
      this.addMark();
      this.isShowRoadAction = true;
      // this.addRoadFun(e);
    },
    addRoadFun(e) {
      
      if (this.roadPointCount == 0) {
        this.setRwMark("起点");
      } else if (this.roadPointCount == 1) {
        this.setRwMark("终点");
      }
      let markerPoint = map.getCenter();
      var gc = new BMap.Geocoder();
      let _this = this;
      gc.getLocation(markerPoint, function (rs) {
        if (!rs.surroundingPois[0]) {
          let address = rs.address;
          if (_this.roadPointCount == 0) {
            _this.roadObject.start = markerPoint;
            _this.roadObject.address_start = address;
            _this.roadPointCount++;
          } else {
            map.clearOverlays();
            _this.roadObject.end = markerPoint;
            _this.roadObject.address_end = address;
            _this.roadPointCount = 0;
            _this.roadList.push(_this.roadObject);
            console.log(_this.roadList);
            _this.roadObject = {};
            _this.setRoadLine();
            if (_this.currentOpt == 4) {
              _this.isShowRoadAction = false;
              _this.$refs.roadPanel.showPanel();
            }
          }
        } else {
          let address = rs.surroundingPois[0].address;
          if (_this.roadPointCount == 0) {
            _this.roadObject.start = markerPoint;
            _this.roadObject.address_start = address;
            _this.roadPointCount++;
          } else {
            map.clearOverlays();
            _this.roadObject.end = markerPoint;
            _this.roadObject.address_end = address;
            _this.roadPointCount = 0;
            _this.roadList.push(_this.roadObject);
            console.log(_this.roadList);
            _this.roadObject = {};
            _this.setRoadLine();
            if (_this.currentOpt == 4) {
              _this.isShowRoadAction = false;
              _this.$refs.roadPanel.showPanel();
            }
          }
        }
      });
    },
    setRoadLine() {
      // 循环显示出所有路段
      let _this = this;
      let arr = _this.roadList;
      for (var i = 0; i < arr.length; i++) {
        _this.getTransit(arr[i].start, arr[i].end, i);
      }
      var myIcon = new BMap.Icon(bikeIcon, new BMap.Size(56, 76));
      function run() {
        for (var m = 0; m < _this.animPathPoints.length; m++) {
          var pts = _this.animPathPoints[m];
          var len = pts.length;
          var carMk = new BMap.Marker(pts[0], { icon: myIcon });
          map.addOverlay(carMk);
          resetMkPoint(1, len, pts, carMk);
        }

        function resetMkPoint(i, len, pts, carMk) {
          carMk.setPosition(pts[i]);
          if (i < len) {
            setTimeout(function () {
              i++;
              resetMkPoint(i, len, pts, carMk);
            }, 100);
          }
        }
      }

      setTimeout(function () {
        run();
      }, 1500);
    },
    // 计算驾车时间和距离
    getTransit(start, end, index) {
      let _this = this;
      var transitObj = {};
      ////alert("-2");
      var searchComplete = function (results) {
        if (transit.getStatus() != BMAP_STATUS_SUCCESS) {
          return;
        }
        var plan = results.getPlan(0);
        transitObj.duration = plan.getDuration(true); //获取时间
        transitObj.distance = plan.getDistance(true); //获取距离
      };
      ////alert("-1");
      this.jiaotongtool=(this.$cookies.get("jiaotongtool").toString());//新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码
      if(this.jiaotongtool=="car")       //新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码
     {////alert("0");
        var transit = new BMap.DrivingRoute(map, 
      { 
        renderOptions: { map: map, autoViewport: true },
        onSearchComplete: searchComplete,
        onMarkersSet: function (routes) {
          // 当地图标记添加完成时调用
          for (var i = 0; i < routes.length; i++) {
            // 判断是否是途经点
            map.removeOverlay(routes[i].marker);
            // 添加自定义标记
            if (i == 0) {
              _this.setRwMark("起点", start);
            } else if (i == 1) {
              _this.setRwMark("终点", end);
            }
          }
        },
        onPolylinesSet: function (Route) {
          for (var i = 0; i < Route.length; i++) {
            var polyline = Route[i].getPolyline(); //获取线条遮挡物
            polyline.setStrokeColor("#fe0072"); //设置颜色
            polyline.setStrokeWeight(7); //设置宽度
            polyline.setStrokeOpacity(0.8); //设置透明度
            _this.animPathPoints.push(Route[i].getPath());
          }
          setTimeout(function () {
            if (index != undefined) {
              _this.$set(_this.roadList[index], "transit", transitObj);
            }
            console.log(_this.roadList);
          }, "0");
        },
      });
     }
      else
      {
        var transit = new BMap.DrivingRoute(map, 
      { 
        renderOptions: { map: map, autoViewport: true },
        policy:BMAP_DRIVING_POLICY_AVOID_HIGHWAYS,
        onSearchComplete: searchComplete,
        onMarkersSet: function (routes) {
          // 当地图标记添加完成时调用
          for (var i = 0; i < routes.length; i++) 
          {            // 判断是否是途经点
            map.removeOverlay(routes[i].marker);
            // 添加自定义标记
            if (i == 0) {
              _this.setRwMark("起点", start);
            } else if (i == 1) {
              _this.setRwMark("终点", end);
            }
          }
        },
        onPolylinesSet: function (Route) {
          for (var i = 0; i < Route.length; i++) {
            var polyline = Route[i].getPolyline(); //获取线条遮挡物
            polyline.setStrokeColor("#fe0072"); //设置颜色
            polyline.setStrokeWeight(7); //设置宽度
            polyline.setStrokeOpacity(0.8); //设置透明度
            _this.animPathPoints.push(Route[i].getPath());
          }
          setTimeout(function () {
            if (index != undefined) {
              _this.$set(_this.roadList[index], "transit", transitObj);
            }
            console.log(_this.roadList);
          }, "0");
        },
      });
      }
      transit.search(start, end);
    },
    openRoadsPanel() 
    {
      //alert("a");
       this.jiaotongtool=(this.$cookies.get("jiaotongtool").toString());//新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码
     //alert("b");
     //alert(this.jiaotongtool);
       if (this.currentOpt == 6) {
        // （多途径点）路段共享
        if (this.rw.roadStatus === 0) {
          // 未选过路段（完成路段选择）
          let arr = this.rw.roadInfo;
          if (this.taskAlgoType !== 2 && !arr.endPoint) {
            this.alertMsg("未完成坐标选取！");
          } else if (this.taskAlgoType == 2 && arr.ways.length < 2) {
            this.alertMsg("回路派送至少需要两个途径点");
          } else if (!arr.startPoint || arr.ways.length === 0) {
            this.alertMsg("未完成坐标选取！");
          } else {
            this.alertMsg("已完成坐标选取！");
           
            console.log(this.rw.roadInfo);
            this.isShowRwAction = false;
            this.isCenterPoint = false;
            this.rw.roadStatus = 1;
            
            this.alertMsg(this.rw.roadInfo.toString());
            if (this.taskAlgoType === 0) {
              ////alert("openRoadsPanel2");
              //alert("c");
              this.handleRwStart(this.jiaotongtool);//新加代码新加代码新加代码新加代码新加代码新加代码新加代
            } else if (this.taskAlgoType === 1) {
              ////alert("openRoadsPanel3");
              //alert("d");
              this.handleTreeStart(this.jiaotongtool);//新加代码新加代码新加代码新加代码新加代码新加代码新加代
            } else if (this.taskAlgoType === 2) {
              ////alert("openRoadsPanel4");
              //alert("e");
              this.handleTspStart(this.jiaotongtool);
            } else {
              ////alert("openRoadsPanel5");
              //alert("f");
              this.handleRwStart(this.jiaotongtool);//新加代码新加代码新加代码新加代码新加代码新加代码新加代
            }
           // document.getElementById("finishRoadBtn").click();            
            // this.setShowAlgoroadCard(1);
            // this.handleTspStart();
          }
        } else if (this.rw.roadStatus === 1) 
        {
          // 已选过路段（打开信息面板）          
          this.$refs.roadWaysPanel.showPanel();
          var x = document.getElementsByClassName("item-text");
          var i;
          
          var everydistance=this.alldistance/this.rw.roadInfo.ways.length;
          var everytimelong=0.0;
          if(this.jiaotongtool=="car")
          {
            everytimelong=(everydistance/100.0);
          }
          else
          {
            everytimelong=(everydistance/25.0);            
          }
          
          var nowtime=this.getnowtime();
          
          for (i = 3; i < x.length-1; i++)
          {
            nowtime=this.Addnowtime(nowtime,everytimelong);            
            x[i].value ="客户电话:"+this.autoNum1()+"。预计时间:"+nowtime+"。"+"录入者：张南天。快递1件。";
          } 
        }
      } else if (this.currentOpt == 5)
       {
        // 多路段共享
        this.isShowRoadAction = false;
        this.$refs.roadsPanel.showPanel();
      }
    },
    autoNum1: function () 
 {
 
  var nuM = [];
  
  while (!(/^1[34578]\d{9}$/.test(nuM))) 
  {//通过随机函数生成电话号码,并存入数组中
    nuM = [];    
  for (var i = 0; i < 11; i++) 
  {
      var num = Math.floor(Math.random() * 10);
      nuM.unshift(num); 
  }
  //把数组中的逗号通过join方法消除掉
  nuM = nuM.join("");
  //通过正则判断号码是否为正常电话号码
}
  nuM = nuM.toString();
  return nuM
 },
    addRoadWithWays(e) {
      if (this.rw.roadStatus === 0) {
        this.isShowRwAction = true;
      }

      this.addMark(e);
    },
    handleRwActionClick(n) {
      let _this = this;
      let markerPoint = map.getCenter();
      if (n == 1) {
        if (this.rw.roadInfo.startPoint) {
          //alert("起点已选好，请勿重复选择！");
        } else {
          this.rw.roadInfo.startPoint = markerPoint;
          this.rw.roadInfo.startAddress = this.address;
          this.setRwMark("起点");
        }
      } else if (n == 2) {
        let roadObj = { point: markerPoint, address: this.address };
        this.rw.roadInfo.ways.push(roadObj);
        this.rw.roadInfo.minimum.push(roadObj);
        this.setRwMark("途径点");
      } else if (n == 3) {
        if (this.rw.roadInfo.endPoint) {
          //alert("终点已选好，请勿重复选择！");
        } else {
          this.rw.roadInfo.endPoint = markerPoint;
          this.rw.roadInfo.endAddress = this.address;
          this.setRwMark("终点");
        }
      }
      console.log(this.rw);
    },
    setRwMark(text, point, iconNum) {
      let markerPoint = "";
      // 判断是否有point参数，若无则默认中心点point
      if (point === undefined) {
        markerPoint = map.getCenter();
      } else {
        markerPoint = point;
      }

      var icon = this.getCurIcon(iconNum);
      var myIcon = new BMap.Icon(icon, new BMap.Size(56, 76));

      let marker = new BMap.Marker(
        new BMap.Point(markerPoint.lng, markerPoint.lat),
        {
          icon: myIcon,
        }
      );

      marker.setLabel(this.getTextLabel(text));
      // marker.setTop(true); // 设置最顶
      // marker.setAnimation(BMAP_ANIMATION_DROP); // 设置动画
      map.addOverlay(marker);
      // 点标记添加点击事件
      let _this = this;
      marker.addEventListener("click", function (e)
       {
        if (_this.messageList.find((item) => item.position == markerPoint))
          return null;
        let content = window.prompt("为当前标记点添加文本标注：");
        if (content) {
          _this.messageList.push({
            position: markerPoint,
            content: content,
          });
        }
       });
       marker.addEventListener("rightclick",function(e)
       {
        if (_this.messageList.find((item) => item.position == markerPoint))
          return null;
        let content = window.prompt("确定删除该途经点吗？","是");
        if (content=="是") 
        {
          var allmarker=this.map.getOverlays();          
          for (var i=0; i < allmarker.length; i++)
          {
            if(allmarker[i].point.lng==markerPoint.lng && allmarker[i].point.lat==markerPoint.lat)
            {   map.removeOverlay(allmarker[i]);
                return;
            }
          }
       }
      });
    },
    // 给标记添加文字
    getTextLabel(text) {
      var offsetSize = new BMap.Size(0, 0);
      var labelStyle = {
        color: "#fff",
        backgroundColor: "#0b99f1",
        border: "0",
        margin: "36px 7px 0",
        boxShadow: "0 0 5px #0b99f1",
        borderRadius: "4px",
        padding: "0 6px",
      };
      //不同数字长度设置不同的样式。
      switch ((text + "").length) {
        case 1:
          labelStyle.fontSize = "14px";
          offsetSize = new BMap.Size(4, 2);
          break;
        case 2:
          labelStyle.fontSize = "12px";
          offsetSize = new BMap.Size(2, 4);
          break;
        case 3:
          labelStyle.fontSize = "10px";
          offsetSize = new BMap.Size(-2, 4);
          break;
        default:
          break;
      }
      var label = new BMap.Label(text, {
        offset: offsetSize,
      });
      label.setStyle(labelStyle);
      return label;
    },
    handleRwStart(drivetool)//新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代
    { 
      // 清空用户所点的标记（后面需要重新定义标记信息）      
      map.clearOverlays();
      let roadInfo = this.rw.roadInfo;
      let classesWays = getClassify(roadInfo);
      let leftWays = getShortestPath(roadInfo, classesWays.leftArr);
      let rightWays = getShortestPath(roadInfo, classesWays.rightArr);
      // 途径点串联成最终渲染数组
      let end = {
        address: roadInfo.endAddress,
        point: roadInfo.endPoint,
        mark: "end",
      };
      let mergeArr = [];
      if (leftWays == false) {
        // 途径点串联成最终渲染数组
        mergeArr = [...rightWays, end];
      } else if (rightWays == false) {
        // 途径点串联成最终渲染数组
        mergeArr = [end, ...leftWays];
      } else {
        leftWays.reverse();
        mergeArr = [...rightWays, end, ...leftWays];
      }
      console.log(mergeArr);
      // let newWays = getShortestPath(roadInfo);
      // roadInfo.ways = newWays;
      // 获取距离及时间
      var _this = this;
      var transitObj = {};
      var searchComplete = function (results) 
      {
        if (driving.getStatus() != BMAP_STATUS_SUCCESS) {
          return;
        }
        var plan = results.getPlan(0);
        transitObj.duration = plan.getDuration(true); //获取时间
        transitObj.distance = plan.getDistance(true); //获取距离
        var s=plan.getDistance(true);    
        _this.alldistance=Number(s.replace("公里",""));
        s=document.getElementById("state").innerHTML +"<br>"+s;
        document.getElementById("state").innerHTML=s;
       //var  leavemsg=(_this.$cookies.get("leavemsg").toString());//新加代码新加代码新加代
       
       //var  leavemsg=window.sessionStorage.getItem('leavemsg');
       if(_this.pointsInfo!="")
       {var leavemsg= _this.pointsInfo;       
       var lvmsgarr=leavemsg.split("▲");   
       //alert(lvmsgarr.length);               
       for (let i = 0; i < lvmsgarr.length; i++)
       {//alert("a");
       if(lvmsgarr.length>0 && i<roadInfo.ways.length)
       {//alert("b");
        var pk1=new BMap.Point(roadInfo.ways[i].point.lng+0.07,roadInfo.ways[i].point.lat-0.01);
        //alert("c");
        var labelopts = {
          position: pk1,//指定文本标注所在的地理位置 
          offset: new BMap.Size(5,-30)//设置文本偏移量
        };
           //alert(lvmsgarr[i]);
            lvmsgarr[i]=lvmsgarr[i].replace("。","<br>");
            //alert("1");
            lvmsgarr[i]=lvmsgarr[i].replace("。","<br>");
            //alert("2");
       var labelmsg = new BMap.Label(lvmsgarr[i],labelopts);
       labelmsg.setStyle({
        color:"#fff",
        fontSize:"14px",
        backgroundColor:"#84C1FF", 
        border:"0",
        fontWeight:"bold"
       });
       map.addOverlay(labelmsg);
       }
      }
    }
      };
      // 设置驾车路线
      if(drivetool=="car")       //新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新
    {////alert("1");
      var driving = new BMap.DrivingRoute(map, 
      {  
        renderOptions: { map: map, autoViewport: true },
        onSearchComplete: searchComplete,
        onMarkersSet: function (routes) {
          //当地图标记添加完成时调用
          for (var i = 0; i < routes.length; i++) {
            //判断是否是途经点
            if (typeof routes[i].Um == "undefined") {
              map.removeOverlay(routes[i].marker); //删除起始默认图标
            } else {
              map.removeOverlay(routes[i].Um); //删除途经默认图标
            }
          }
        },
        onPolylinesSet: function (Route) {
          for (var i = 0; i < Route.length; i++) {
            var polyline = Route[i].getPolyline(); //获取线条遮挡物
            polyline.setStrokeColor("#fe0072"); //设置颜色
            polyline.setStrokeWeight(7); //设置宽度
            polyline.setStrokeOpacity(0.8); //设置透明度
            _this.animPathPoints.push(Route[i].getPath());
          }
          setTimeout(function () {
            console.log(transitObj);
          }, "0");
          // alert("");map.clearOverlays();
        },
      });
      driving.search(roadInfo.startPoint, roadInfo.startPoint, {
        waypoints: mergeArr,
      });
    }
      else                              //新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新
      {
      var driving = new BMap.DrivingRoute(map, 
      {  
        renderOptions: { map: map, autoViewport: true },
        policy:BMAP_DRIVING_POLICY_AVOID_HIGHWAYS,
        onSearchComplete: searchComplete,
        onMarkersSet: function (routes) {
          //当地图标记添加完成时调用
          for (var i = 0; i < routes.length; i++) {
            //判断是否是途经点
            if (typeof routes[i].Um == "undefined") {
              map.removeOverlay(routes[i].marker); //删除起始默认图标
            } else {
              map.removeOverlay(routes[i].Um); //删除途经默认图标
            }
          }
        },
        onPolylinesSet: function (Route) {
          for (var i = 0; i < Route.length; i++) {
            var polyline = Route[i].getPolyline(); //获取线条遮挡物
            polyline.setStrokeColor("#fe0072"); //设置颜色
            polyline.setStrokeWeight(7); //设置宽度
            polyline.setStrokeOpacity(0.8); //设置透明度
            _this.animPathPoints.push(Route[i].getPath());
          }
          setTimeout(function () {
            console.log(transitObj);
          }, "0");
          // alert("");map.clearOverlays();
        },
      });
      driving.search(roadInfo.startPoint, roadInfo.startPoint, {
        waypoints: mergeArr,
      });
      }

      // driving.search(roadInfo.startPoint, roadInfo.endPoint, {
      //   waypoints: roadInfo.ways,
      // });
      // 添加路段标记
      this.setRwMark("起点", roadInfo.startPoint);
      var markNum = 1;
      for (var i = 0; i < mergeArr.length; i++) {
        var item = mergeArr[i];
        if (item.mark && item.mark == "end") {
          this.setRwMark("终点", item.point);
        } else {
          this.setRwMark(`途径${markNum}`, item.point);
          markNum += 1;
        }
      }
      var myIcon = new BMap.Icon(bikeIcon, new BMap.Size(56, 76));
      function run() {
        // for (var m = 0; m < _this.animPathPoints.length; m++) {
        var pts = _this.animPathPoints.flat();
        var len = pts.length;
        var carMk = new BMap.Marker(pts[0], { icon: myIcon });
        map.addOverlay(carMk);
        resetMkPoint(1, len, pts, carMk);
        // }

        function resetMkPoint(i, len, pts, carMk) {
          carMk.setPosition(pts[i]);
          if (i < len) {
            setTimeout(function () {
              i++;
              resetMkPoint(i, len, pts, carMk);
            }, 100);
          }
        }
      }

      setTimeout(function () {
        run();
      }, 1500);

      // 添加起点到终点连接的直线
      var polyline = new BMap.Polyline(
        [
          new BMap.Point(end.point.lng, end.point.lat),
          new BMap.Point(roadInfo.startPoint.lng, roadInfo.startPoint.lat),
        ],
        {
          strokeColor: "red",
          strokeWeight: 2,
          strokeOpacity: 0.5,
        }
      );
      map.addOverlay(polyline);
      // 数据给到导航面板
      this.callAppLink = `baidumap://map/navi?location=${roadInfo.endPoint.lat},${roadInfo.endPoint.lng}&coord_type=bd09ll&type=BLK&viaPoints&src=ios.baidu.openAPIdemo`;
      let navObject = {};
      this.$set(navObject, "type", "roadWays");
      this.$set(navObject, "data", mergeArr);
      this.navigationData = navObject;
    },
    getnowtime:function()
    {    
    var nowdate = new Date();    
    var h = nowdate.getHours();    
    var m = nowdate.getMinutes();
    var s = nowdate.getSeconds();   
    return  h +":" + m + ":" + s;
    },
    Addnowtime:function(timestr,addnum) 
    {
      var nowdate = new Date();
      var timeval=timestr.split(":");
      var h = parseInt(timeval[0])+Math.floor(addnum);
      //alert(parseInt(timeval[1]));
      //alert(Math.floor((addnum-Math.floor(addnum))*60));
      var m = parseInt(timeval[1])+Math.floor((addnum-Math.floor(addnum))*60);
      //alert(m);
      if(m>=60)
      {
        h=h+1;
        m=m-60;
      }
      if(h>23)
      {
        h=h-24;
      }
      var s = nowdate.getSeconds();

      return  h +":" + m + ":" + s+"";
    },
    // 最小生成树原型排序
    _sort(property) {
      return function (obj1, obj2) {
        var value1 = obj1[property];
        var value2 = obj2[property];
        return value2 - value1; // 降序
      };
    },
    handleTreeStart(drivetool) {
      map.clearOverlays();
      // 定义
      let _this = this;
      // 起点与第一个点
      let _start = new Array();
      let _ways = new Array();
      // 用户选择的所有途径点(获取数据：地址(address)、经纬度(point)，例如 _pointArr[i].address)
      let _pointArr = _this.rw.roadInfo.ways;
      // 结果数组：存放经纬度对象{lng:xxx,lat:xxx}  (生成路线就是用的这个数组)
      let res = [];
      // clac:起点到第一个途径点
      for (let i = 0; i < _pointArr.length; i++) {
        // new Edge(起点，终点，两点之间的距离)，获取Edge对象内的数据：起点(_first),终点(_second),两点之间的距离(_value)，例如 _edge._first
        let _edge = new Edge(
          _this.rw.roadInfo.startPoint,
          _pointArr[i].point,
          map.getDistance(_this.rw.roadInfo.startPoint, _pointArr[i].point)
        );
        _start.push(_edge);
      }
      _start = _start.sort(_this._sort("_value"))[0]._second;
      // clac:所有途径点的排序
      // TODO: 完善算法
      for (var i = 0; i <= _pointArr.length; i++) {
        let a = i + 1;
        if (a >= _pointArr.length) {
          var _edge = new Edge(
            _pointArr[i].point,
            _this.rw.roadInfo.endPoint,
            map.getDistance(_pointArr[i].point, _this.rw.roadInfo.endPoint)
          );
          _ways.push(_edge);
          break;
        } else {
          var _edge = new Edge(
            _pointArr[i].point,
            _pointArr[a].point,
            map.getDistance(_pointArr[i].point, _pointArr[a].point)
          );
          _ways.push(_edge);
          console.log(_ways);
        }
      }
      _ways = _ways.sort(_this._sort("_value"));
      console.log(_ways);
      // 把排序后的结果push到结果数组里。
      _ways.forEach(function (item) {
        res.push(item._first);
      });
      console.log(res);
      // 获取距离及时间
      var transitObj = {};
      var searchComplete = function (results) {
        if (driving.getStatus() != BMAP_STATUS_SUCCESS) {
          return;
        }
        var plan = results.getPlan(0);
        transitObj.duration = plan.getDuration(true); //获取时间
        transitObj.distance = plan.getDistance(true); //获取距离
          
      };
      // 初始化路线, route / init / calc 详细-> ./assets/js/minimums.js
      var route = BMAP_DRIVING_POLICY_LEAST_DISTANCE;
      
      if(drivetool=="car")       //新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新
    {////alert("2");
      var driving = new BMap.DrivingRoute(map, 
      {
        renderOptions: { map: map, autoViewport: true },
        // policy: route,
        onSearchComplete: searchComplete,
        onMarkersSet: function (routes) {
          //当地图标记添加完成时调用
          for (var i = 0; i < routes.length; i++) {
            //判断是否是途经点
            if (typeof routes[i].Um == "undefined") {
              map.removeOverlay(routes[i].marker); //删除起始默认图标
            } else {
              map.removeOverlay(routes[i].Um); //删除途经默认图标
            }
          }
        },
        onPolylinesSet: function (Route) {
          for (var i = 0; i < Route.length; i++) {
            var polyline = Route[i].getPolyline(); //获取线条遮挡物
            polyline.setStrokeColor("#fe0072"); //设置颜色
            polyline.setStrokeWeight(6); //设置宽度
            polyline.setStrokeOpacity(0.7); //设置透明度
            _this.animPathPoints.push(Route[i].getPath());
          }
          setTimeout(function () {
            console.log(transitObj);
          }, "0");
        },
      });
    }
      else 
      {
        var driving = new BMap.DrivingRoute(map, 
      {
        renderOptions: { map: map, autoViewport: true },
        policy:BMAP_DRIVING_POLICY_AVOID_HIGHWAYS,
        onSearchComplete: searchComplete,
        onMarkersSet: function (routes) {
          //当地图标记添加完成时调用
          for (var i = 0; i < routes.length; i++) {
            //判断是否是途经点
            if (typeof routes[i].Um == "undefined") {
              map.removeOverlay(routes[i].marker); //删除起始默认图标
            } else {
              map.removeOverlay(routes[i].Um); //删除途经默认图标
            }
          }
        },
        onPolylinesSet: function (Route) {
          for (var i = 0; i < Route.length; i++) {
            var polyline = Route[i].getPolyline(); //获取线条遮挡物
            polyline.setStrokeColor("#fe0072"); //设置颜色
            polyline.setStrokeWeight(6); //设置宽度
            polyline.setStrokeOpacity(0.7); //设置透明度
            _this.animPathPoints.push(Route[i].getPath());
          }
          setTimeout(function () {
            console.log(transitObj);
          }, "0");
        },
      });
      }
      // for (let j = 0; j < _pointArr.length; j++) {
      //   res.push(_pointArr[j].point);
      // }
      res.push(_this.rw.roadInfo.endPoint);
      // TODO:
      // res.shift(); // 删除第1个
      // res.splice(1, 1); // 删除第2个
      // res.splice(0, 0, _start); //在第一个位置插入第一个途径点的坐标
      console.log(res);
      // 如果需要返程，如果返程则把endPoint改成startPoint
      driving.search(_this.rw.roadInfo.startPoint, _this.rw.roadInfo.endPoint, {
        waypoints: res,
      });
      // 添加起点到终点连接的直线
      // let polyline = new BMap.Polyline(
      //   [
      //     new BMap.Point(
      //       _this.rw.roadInfo.endPoint.lng,
      //       _this.rw.roadInfo.endPoint.lat
      //     ),
      //     new BMap.Point(
      //       _this.rw.roadInfo.startPoint.lng,
      //       _this.rw.roadInfo.startPoint.lat
      //     ),
      //   ],
      //   {
      //     strokeColor: "#1DA1F2",
      //     strokeWeight: 2,
      //     strokeOpacity: 0.8,
      //     strokeStyle: "dashed",
      //   }
      // );
      // map.addOverlay(polyline);
      // 添加路段标记

      var myIcon = new BMap.Icon(bikeIcon, new BMap.Size(56, 76));
      function run() {
        // for (var m = 0; m < _this.animPathPoints.length; m++) {
        var pts = _this.animPathPoints.flat();
        var len = pts.length;
        var carMk = new BMap.Marker(pts[0], { icon: myIcon });
        map.addOverlay(carMk);
        resetMkPoint(1, len, pts, carMk);
        // }

        function resetMkPoint(i, len, pts, carMk) {
          carMk.setPosition(pts[i]);
          if (i < len) {
            setTimeout(function () {
              i++;
              resetMkPoint(i, len, pts, carMk);
            }, 100);
          }
        }
      }

      setTimeout(function () {
        run();
      }, 1500);

      this.setRwMark("起点", _this.rw.roadInfo.startPoint);
      this.setRwMark("终点", _this.rw.roadInfo.endPoint);
      var markNum = 1;
      for (var i = 0; i < res.length; i++) {
        var item = res[i];
        if (i == res.length - 1) {
          // this.setRwMark("终点", item);
          return false; // 如果需要返程，把上面一行取消注释，这行注释掉
        } else {
          this.setRwMark(`途径${markNum}`, item);
          markNum += 1;
        }
      }
    },
    handleTspStart(drivetool) 
    {
      // 清空用户所点的标记（后面需要重新定义标记信息）
      ////alert('handleTspStart');
      map.clearOverlays();
      // 存放每种方式
      let roadResArr = [];
      let roadInfo = this.rw.roadInfo;
      //alert("0");

      //alert("1");
      let start = {
        address: roadInfo.startAddress,
        point: roadInfo.startPoint,
      };
       for (let i = 0; i < roadInfo.ways.length; i++) 
       {
        let end = {
          address: roadInfo.ways[i].address,
          point: roadInfo.ways[i].point,
        };


        let roadWays = roadInfo.ways.slice();
        roadWays.splice(i, 1);
        let formatRoadInfo = {
          startPoint: start.point,
          endPoint: end.point,
          ways: roadWays,
        };
        let classesWays = getClassify(formatRoadInfo);
        // 进行组合
        let leftWays = getShortestPath(roadInfo, classesWays.leftArr);
        let rightWays = getShortestPath(roadInfo, classesWays.rightArr);
        let mergeArr = [];
        if (leftWays == false) {
          // 途径点串联成最终渲染数组
          mergeArr = [...rightWays, end];
        } else if (rightWays == false) {
          // 途径点串联成最终渲染数组
          mergeArr = [end, ...leftWays];
        } else {
          leftWays.reverse();
          mergeArr = [...rightWays, end, ...leftWays];
        }
        // 获取总距离
        var _this = this;
        (function () {
          var transitObj = {};
          var searchComplete = function (results)
           {
            if (driving.getStatus() != BMAP_STATUS_SUCCESS) {
              return;
            }
            var plan = results.getPlan(0);
            transitObj.duration = plan.getDuration(true); //获取时间
            transitObj.distance = plan.getDistance(true); //获取距离
            transitObj.index = i;         
          };
          // 设置驾车路线
          ////alert(drivetool);
          if(drivetool=="car")       //新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码
        {//alert("2");
        var driving = new BMap.DrivingRoute(map, 
          {
            renderOptions: { map: map, autoViewport: true },
            onSearchComplete: searchComplete,
            onMarkersSet: function (routes) {
              //当地图标记添加完成时调用
              for (var i = 0; i < routes.length; i++) {
                //判断是否是途经点
                if (typeof routes[i].Um == "undefined") {
                  map.removeOverlay(routes[i].marker); //删除起始默认图标
                } else {
                  map.removeOverlay(routes[i].Um); //删除途经默认图标
                }
              }
            },
            onPolylinesSet: function (Route) {
              for (var i = 0; i < Route.length; i++) {
                var polyline = Route[i].getPolyline(); //获取线条遮挡物
                polyline.setStrokeColor("#fe0072"); //设置颜色
                polyline.setStrokeWeight(7); //设置宽度
                polyline.setStrokeOpacity(0.8); //设置透明度
              }
              roadResArr.push(JSON.parse(JSON.stringify(transitObj)));
              // 获取到所有路段距离和时间结果后，清除地图上的覆盖物
              map.clearOverlays();
            },
          });
          driving.search(roadInfo.startPoint, roadInfo.startPoint, {
            waypoints: mergeArr,
          });
        }
          else
        {//alert("3");
          var driving = new BMap.DrivingRoute(map, 
          {
            renderOptions: { map: map, autoViewport: true },
            policy:BMAP_DRIVING_POLICY_AVOID_HIGHWAYS,
            onSearchComplete: searchComplete,
            onMarkersSet: function (routes) {
              //当地图标记添加完成时调用
              for (var i = 0; i < routes.length; i++) {
                //判断是否是途经点
                if (typeof routes[i].Um == "undefined") {
                  map.removeOverlay(routes[i].marker); //删除起始默认图标
                } else {
                  map.removeOverlay(routes[i].Um); //删除途经默认图标
                }
              }
            },
            onPolylinesSet: function (Route) {
              for (var i = 0; i < Route.length; i++) {
                var polyline = Route[i].getPolyline(); //获取线条遮挡物
                polyline.setStrokeColor("#fe0072"); //设置颜色
                polyline.setStrokeWeight(7); //设置宽度
                polyline.setStrokeOpacity(0.8); //设置透明度
              }

              roadResArr.push(JSON.parse(JSON.stringify(transitObj)));

              // 获取到所有路段距离和时间结果后，清除地图上的覆盖物
              map.clearOverlays();
            },
          });
          driving.search(roadInfo.startPoint, roadInfo.startPoint, {
            waypoints: mergeArr,
          });
        } 
         })();

       }
       this.alertMsg("正在计算路径，请稍候 ...");
      
      setTimeout(() => 
      {
        // 获取最短距离路段index
        let oMinIndex = this.calcShortDistance(roadResArr);
        // 生成最短路段
        let end = {
          address: roadInfo.ways[oMinIndex].address,
          point: roadInfo.ways[oMinIndex].point,
        };
        let roadWays = roadInfo.ways.slice();
        roadWays.splice(oMinIndex, 1);
        let formatRoadInfo = {
          startPoint: start.point,
          endPoint: end.point,
          ways: roadWays,
        };
        let classesWays = getClassify(formatRoadInfo);
        // 进行途径点串联组合成最终渲染数组
        let leftWays = getShortestPath(roadInfo, classesWays.leftArr);
        let rightWays = getShortestPath(roadInfo, classesWays.rightArr);
        let mergeArr = [];
        if (leftWays == false) {
          mergeArr = [...rightWays, end];
        } else if (rightWays == false) {
          mergeArr = [end, ...leftWays];
        } else {
          leftWays.reverse();
          mergeArr = [...rightWays, end, ...leftWays];
        }
        // 获取时间距离
        var searchComplete = function (results)
        {
          if (driving.getStatus() != BMAP_STATUS_SUCCESS) {
            return;
          }
          var plan = results.getPlan(0);
          var s1=plan.getDistance(true);          
          _this.alldistance=Number(s1.replace("公里",""));          
          s1=document.getElementById("state").innerHTML +"<br>"+s1;
          document.getElementById("state").innerHTML=s1;
          if(_this.pointsInfo!="")
          {var leavemsg1= _this.pointsInfo;
          //var leavemsg1=_this.$cookies.get("leavemsg").toString();//新加代码新加代码新加代新加代码新加代码新加代新加代码新加代码新加代    
         
         // var  leavemsg1=window.sessionStorage.getItem('leavemsg');

          var lvmsgarr=leavemsg1.split("▲"); 
          //alert(lvmsgarr.length); 
          for (let i = 0; i < lvmsgarr.length; i++)
          {  
          if(lvmsgarr.length>0 && i<roadInfo.ways.length)
          {var pkk=new BMap.Point(roadInfo.ways[i].point.lng+0.07,roadInfo.ways[i].point.lat-0.01);
            var labelopts = {
              position: pkk,// 指定文本标注所在的地理位置 
              offset: new BMap.Size(5,-30)// 设置文本偏移量
            };
            //alert(lvmsgarr[i]);
            lvmsgarr[i]=lvmsgarr[i].replace("。","<br>");
            //alert("1");
            lvmsgarr[i]=lvmsgarr[i].replace("。","<br>");
            //alert("2");
            var labelmsg = new BMap.Label(lvmsgarr[i],labelopts);
             labelmsg.setStyle
             ({
              color:"#fff",
              fontSize:"14px",
              backgroundColor:"#84C1FF", 
              border:"0",
              fontWeight:"bold"
            });
            map.addOverlay(labelmsg);
          }
          }
        }
         };
          
        const _this = this;
        // 设置驾车路线
        if(drivetool=="car")       //新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码
       {////alert("4");
        var driving = new BMap.DrivingRoute(map, 
        {
          renderOptions: { map: map, autoViewport: true },
          onSearchComplete: searchComplete,
          onMarkersSet: function (routes) {
            //当地图标记添加完成时调用
            for (var i = 0; i < routes.length; i++) {
              //判断是否是途经点
              if (typeof routes[i].Um == "undefined") {
                map.removeOverlay(routes[i].marker); //删除起始默认图标
              } else {
                map.removeOverlay(routes[i].Um); //删除途经默认图标
              }
            }
          },
          onPolylinesSet: function (Route) {
            for (var i = 0; i < Route.length; i++) {
              var polyline = Route[i].getPolyline(); //获取线条遮挡物
              polyline.setStrokeColor("#fe0072"); //设置颜色
              polyline.setStrokeWeight(7); //设置宽度
              polyline.setStrokeOpacity(0.8); //设置透明度
              _this.animPathPoints.push(Route[i].getPath());
            }
          },
        });
        driving.search(roadInfo.startPoint, roadInfo.startPoint, {
          waypoints: mergeArr,
        });
      }
        else
        {////alert("5");
        var driving = new BMap.DrivingRoute(map, 
        {
          renderOptions: { map: map, autoViewport: true },
          policy:BMAP_DRIVING_POLICY_AVOID_HIGHWAYS,
          onSearchComplete: searchComplete,
          onMarkersSet: function (routes) {
            //当地图标记添加完成时调用
            for (var i = 0; i < routes.length; i++) {
              //判断是否是途经点
              if (typeof routes[i].Um == "undefined") {
                map.removeOverlay(routes[i].marker); //删除起始默认图标
              } else {
                map.removeOverlay(routes[i].Um); //删除途经默认图标
              }
            }
          },
          onPolylinesSet: function (Route) {
            for (var i = 0; i < Route.length; i++) {
              var polyline = Route[i].getPolyline(); //获取线条遮挡物
              polyline.setStrokeColor("#fe0072"); //设置颜色
              polyline.setStrokeWeight(7); //设置宽度
              polyline.setStrokeOpacity(0.8); //设置透明度
              _this.animPathPoints.push(Route[i].getPath());
            }
          },
        });
        driving.search(roadInfo.startPoint, roadInfo.startPoint, {
          waypoints: mergeArr,
        });
        }

        // 添加自定义标记
        _this.setRwMark("起点", roadInfo.startPoint);

        for (var i = 0; i < mergeArr.length; i++) {
          var item = mergeArr[i];
          _this.setRwMark(`途径${i + 1}`, item.point);
        }

        var myIcon = new BMap.Icon(bikeIcon, new BMap.Size(56, 76));

        function run() {
          // for (var m = 0; m < _this.animPathPoints.length; m++) {
          var pts = _this.animPathPoints.flat();
          var len = pts.length;
          var carMk = new BMap.Marker(pts[0], { icon: myIcon });
          map.addOverlay(carMk);
          resetMkPoint(1, len, pts, carMk);
          // }

          function resetMkPoint(i, len, pts, carMk) {
            carMk.setPosition(pts[i]);
            if (i < len) {
              setTimeout(function () {
                i++;
                resetMkPoint(i, len, pts, carMk);
              }, 100);
            }
          }
        }

        setTimeout(function () {
          run();
        }, 1500);

        // 数据给到导航面板
        let navObject = {};
        _this.$set(navObject, "type", "roadWays");
        _this.$set(navObject, "data", mergeArr);
        _this.navigationData = navObject;
      }, 2500);
    },
    // 比对出数组中最短距离
    calcShortDistance(roadResArr) {
      let numArr = [];
      for (let i = 0; i < roadResArr.length; i++) {
        let num = +roadResArr[i].distance.replace("公里", "");
        numArr.push(num);
      }
      let oMinIndex = this.finMinIndex(numArr, 0);
      let oMinNum = roadResArr[oMinIndex].index;
      return oMinNum;
    },
    // 查找数组最小值的位置
    finMinIndex(arr, start) {
      var oMin = arr[0];
      var oMinIndex = start;

      for (var i = 0; i < arr.length; i++) {
        if (arr[i] < oMin) {
          oMin = arr[i];
          oMinIndex = i;
        }
      }
      return oMinIndex;
    },
    // 途径点规划面板选项
    changeAlgoroadOpt(i) {
      if (i == this.algoroadOpt) {
        return false;
      }
      if (i == 0) {
        this.handleRwStart(this.jiaotongtool);
      } else if (i == 1) {
        this.handleTreeStart(this.jiaotongtool);
      } else if (i == 2) {
        this.handleTspStart(this.jiaotongtool);
        
      }
      this.algoroadOpt = i;
    },
    // 处理途径点规划选项面板显示
    // setShowAlgoroadCard(opt) {
    //   if (opt == 1) {
    //     // 显示
    //     this.$refs.algoroadCard.style.bottom = 75 + "px";
    //     this.$refs.finishRoadBtn.style.bottom = 200 + "px";
    //     this.$refs.oneMarkAddress.style.bottom = 200 + "px";
    //   } else {
    //     // 隐藏
    //     this.$refs.algoroadCard.style.bottom = -120 + "px";
    //     this.$refs.finishRoadBtn.style.bottom = 150 + "px";
    //     this.$refs.oneMarkAddress.style.bottom = 80 + "px";
    //   }
    // },
    // 设置选项面板参数
    setAlgoroadCardInfo(type, num, msg, title) {
      this.algoroadCardInfo.type = type;
      this.algoroadCardInfo.num = num;
      this.algoroadCardInfo.msg = msg;
      this.algoroadCardInfo.title = title;
    },
    // 打开导航选择面板
    openNavCard() {
      this.$refs.NavigationCard.showCard();
    },
    // 提示弹窗
    alertMsg(txt) {
      this.alertMessage = txt;
      this.$refs.message.style.opacity = "1";
      this.$refs.message.style.top = "115px";
      setTimeout(() => {
        this.$refs.message.style.opacity = "0";
      }, 800);
      setTimeout(() => {
        this.$refs.message.style.top = "45px";
      }, 1200);
    },
    // 重置单点/多点状态
    resetMarkData() {
      this.isCenterPoint = false;
      this.isOneMark = false;
      this.isArrMark = false;
      this.isArrCount = false;
    },
    // 重置自作地图状态
    resetMapData() {
      drawingManager.close();
      let drawingPanel = document.querySelector(".BMapLib_Drawing_panel");
      drawingPanel.style.display = "none";
      map.enableDragging();
      map.removeEventListener("touchmove");
      map.removeEventListener("touchend");
    },
    // 重置路段/多路段状态
    resetRoadData() {
      this.roadList = [];
      this.roadPointCount = 0;
      this.roadObject = {};
      this.isShowFinishRoadBtn = false;
      this.isShowRoadAction = false;
    },
    // 重置（多途径点）路段状态
    resetRwData() {
      this.rw.roadStatus = 0;
      this.rw.roadInfo.startAddress = "";
      this.rw.roadInfo.startPoint = "";
      this.rw.roadInfo.endAddress = "";
      this.rw.roadInfo.endPoint = "";
      this.rw.roadInfo.ways = [];
      this.isShowRwAction = false;
      this.isShowFinishRoadBtn = false;
      // this.setShowAlgoroadCard(0);
    },
    openDistanceTool(e) {
      const { distanceTool } = this;
      distanceTool && distanceTool.open();
    },
    toggleList() {
      if (this.listShow == true) {
        this.unListStyle = { background: "#0b99f1" };
        this.unListCode = "";
        this.listShow = false;
      } else {
        this.unListStyle = { background: "#ff5252" };
        this.unListCode = "×";
        this.listShow = true;
      }
    },
    ...mapMutations({
      changeOpt: "CHANGE_CURRENT_OPT",
    }),
    getNonceStr() {
      let text = "";
      const possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 16; i += 1) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text;
    },
    getTimestamp() {
      return `${new Date().valueOf()}`.slice(0, -3);
    },
  },
  mounted() {
    this.socket.open();
    this.socket.on("connect", function () {
      console.log("连接成功");
    });
    this.socket.on("user_send_point", (data) => {
      this.rw.roadInfo.ways.push({ point: data.point });
      console.log(data.iconNum);
      this.setRwMark("途径点", data.point, data.iconNum);
    });
    console.log("上次调试[2022/02/21 04:45] ");
    let _this = this;
    let appId = "wxa6794a59316a1f9d";
    let secret = "06dd94cd22d35748f05b33fe9cd34568";
    let time = _this.getTimestamp();
    let non = _this.getNonceStr();
    let sign = "";
    _this.$http
      .get(
        `wx/token?grant_type=client_credential&appid=${appId}&secret=${secret}`
      )
      .then(function (res) {
        _this.$http
          .get(
            `wx/ticket/getticket?access_token=${res.data.access_token}&type=jsapi`
          )
          .then(function (ticket) {
            _this.$http
              .post("service/shareAuth", {
                apiTicket: ticket.data.ticket,
                noncestr: non,
                timestamp: time,
                url: window.location.href.split("#")[0],
              })
              .then(function (oSign) {
                sign = oSign.data;
                wx.config({
                  debug: false,
                  appId: appId,
                  timestamp: time,
                  nonceStr: non,
                  signature: sign,
                  jsApiList: ["updateAppMessageShareData"],
                });
                wx.ready(function () {
                  wx.updateAppMessageShareData({
                    title: "您的好友给你分享了坐标信息",
                    desc: "点击即可查看更多详细内容 - 智慧共享导航",
                    link: window.location.href.split("#")[0],
                    imgUrl: "https://i.loli.net/2020/12/21/Yr1iysTULx2ZBob.png",
                    success: function () {},
                  });
                });
              });
          });
      });
  },
};
</script>

<style lang="less" scoped>
@import "../assets/less/Index.less";
@import "../assets/less/Header.less";
</style>
